import { TableTemplate } from "components/templates/default/table/TableTemplate";
import PaginationComponent from "components/blocks/pagination";
import * as s from "./ThumbnailStyled";
import PrimaryButton from "components/atoms/buttons/PrimaryButton";

import { Text, UnderlineText } from "components/atoms/text/Text";
import { COLORS } from "styles/colors";
import StorageLabel from "components/blocks/storage/StorageLabel";
import BigPopupNoHeaderTemplate from "components/templates/modal/big/BigPopupNoHeaderTemplate";
import CLOSE_ICON from "assets/icons/sidenav/x.svg";
import { ModalInput } from "components/atoms/input/modal/ModalInput";
import ThumbnailFilter from "./ThumbnailFilter";
import TimeSelect from "components/atoms/select/date/TimeSelect";
import DateSelect from "components/atoms/select/date/DateSelect";
import { useNavigate } from "react-router-dom";
import DefaultThumbnail from "components/atoms/image/DefaultThumbnail";
import { StorageWrapper } from "components/templates/default/table/TableTemplateStyled";
import ThumbnailItem from "./ThumbnailItem";
import {
  DateTime,
  ThumbnailData,
  ThumbnailFilterViewItem,
  ThumbnailViewItem,
} from "api/interfaces/reportInterface.interface";
import { BasePagination } from "api/interfaces/commonInterface.interface";
import { Option } from "utils/options";
import { getRecorderTimeFormat } from "utils/timeUtil";
import { ProfileAccountInfo } from "api/interfaces/accountInterface.interface";
import SelectComponent from "components/atoms/select/SelectComponent";
import { useMenu } from "hook/useMenu";

type Props = {
  title: string | undefined;
  dateTime: DateTime[];
  listQueryInfo: BasePagination;
  thumbnailFilterQueryInfo: BasePagination;
  recorderList: Option[];
  recorderListIsFetching: boolean;
  cameraList: Option[];
  cameraListIsFetching: boolean;
  filterDateList: string[];
  isOpenFilter: boolean;
  isModal: boolean;
  isFilterApply: boolean;
  onChangeOpenFilter: () => void;
  onChangeModal: (
    popupData?: ThumbnailData,
    recorderName?: string,
    cameraName?: string
  ) => void;
  onChangeIsFilter: () => void;
  onSearch: () => void;
  onChangePage: (page: number, totalRows: number) => void;
  onChangePageFilterTable: (page: number, totalRows: number) => void;
  selectFilterRecorder: string;
  selectFilterCamera: string;
  selectFilterDate: string;
  onChangeFilterRecorder: (value: string) => void;
  onChangeFilterCamera: (value: string) => void;
  onChangeFilterDate: (date: Date) => void;
  listTotalCount: number;
  onChangeSearchTime: (value: string) => void;
  onChangeSearchDate: (date: Date) => void;
  selectedDate: string;
  selectedTime: string;
  selectedTimeOption: Option[];
  thumbnailList: ThumbnailViewItem[];
  thumbnailFilterList: ThumbnailFilterViewItem[];
  markedDay: string[];
  selectedAccount: ProfileAccountInfo;
  modalData?: ThumbnailViewItem;
  validateFilterDate: boolean;
};

export default function ThumbnailPresenter(props: Props): JSX.Element {
  const navigate = useNavigate();
  const { menuNavigation } = useMenu({});

  const sub = (
    <StorageWrapper>
      <StorageLabel />
    </StorageWrapper>
  );

  const titleComponent = [
    {
      label: "Report List",
      onClick: () => menuNavigation({ to: "/reports" }),
      //navigate("/reports"),
    },
    {
      label: props.title,
    },
  ];

  return (
    <>
      <TableTemplate noSearch buttons={sub} titleComponent={titleComponent}>
        <s.Header>
          <s.HeaderSelect>
            {!props.isFilterApply ? (
              <>
                <div className="select-wrapper">
                  <DateSelect
                    value={props.selectedDate}
                    markDays={props.markedDay}
                    onChange={props.onChangeSearchDate}
                    data-testid="reports-view-thumbnail-date-select-change-search-date"
                  />
                </div>
                <div className="select-wrapper">
                  <TimeSelect
                    options={props.selectedTimeOption}
                    defaultValue={props.selectedTimeOption[0]?.value}
                    value={
                      props.selectedTime || props.selectedTimeOption[0]?.value
                    }
                    onChange={props.onChangeSearchTime}
                    data-testid="reports-view-thumbnail-time-select-change-search-time"
                  />
                </div>
              </>
            ) : (
              <Text fontSize={18} bold>
                {props.thumbnailFilterList !== undefined &&
                props.thumbnailFilterList.length > 0
                  ? props.thumbnailFilterList[0].recorderName
                  : ""}
              </Text>
            )}

            {/* 
               <mediaQuery.Default>
                {props.isFilterApply && (
                  <Text fontSize={18} bold>
                    {props.thumbnailFilterList !== undefined &&
                    props.thumbnailFilterList.length > 0
                      ? props.thumbnailFilterList[0].recorderName
                      : ""}
                  </Text>
                )}
               </mediaQuery.Default> */}
          </s.HeaderSelect>

          <s.RightHeader>
            {/* <mediaQuery.Default> */}
            {props.isFilterApply && (
              <UnderlineText
                color={COLORS.BUTTONS1}
                onClick={props.onChangeIsFilter}
                data-testid="reports-view-thumbnail-underline-text-change-is-filter"
              >
                Clear Filter
              </UnderlineText>
            )}

            {/* </mediaQuery.Default> */}
            <PrimaryButton
              buttonType="cancel"
              label="Filter"
              onClickBtn={props.onChangeOpenFilter}
              data-testid="reports-view-thumbnail-primary-button-change-open-filter"
            />

            {props.isOpenFilter && (
              <s.FilterContainer>
                <ModalInput label="Recorder">
                  <SelectComponent
                    options={props.recorderList}
                    loading={props.recorderListIsFetching}
                    value={
                      props.selectFilterRecorder !== undefined &&
                      props.selectFilterRecorder !== ""
                        ? props.recorderList.find((option) => {
                            return option.value === props.selectFilterRecorder;
                          })
                        : props.recorderList[0]
                    }
                    onChange={props.onChangeFilterRecorder}
                    data-testid="reports-view-thumbnail-selects-change-filter-recorder"
                  />
                </ModalInput>
                <ModalInput label="Camera">
                  <SelectComponent
                    options={props.cameraList}
                    loading={props.cameraListIsFetching}
                    value={
                      props.selectFilterCamera !== undefined &&
                      props.selectFilterCamera !== ""
                        ? props.cameraList.find((option) => {
                            return option.value === props.selectFilterCamera;
                          })
                        : props.cameraList[0]
                    }
                    onChange={props.onChangeFilterCamera}
                    data-testid="reports-view-thumbnail-selects-change-filter-camera"
                  />
                </ModalInput>
                <ModalInput label="Date">
                  <DateSelect
                    markDays={props.filterDateList}
                    value={props.selectFilterDate}
                    onChange={props.onChangeFilterDate}
                    disabled={!props.validateFilterDate}
                    data-testid="reports-view-thumbnail-date-select-change-filter-date"
                  />
                </ModalInput>
                <PrimaryButton
                  label="Search"
                  onClickBtn={props.onSearch}
                  data-testid="reports-view-thumbnail-primary-button-search"
                />
              </s.FilterContainer>
            )}
          </s.RightHeader>
        </s.Header>
        {props.isFilterApply ? (
          <>
            <s.FilterGridWrapper>
              {props.thumbnailFilterList.map((item, index) => (
                <>
                  <ThumbnailFilter
                    channelName={item.cameraName}
                    recorderName={item.recorderName}
                    data={item.thumbnails}
                    selectedAccount={props.selectedAccount}
                    onChangeModal={props.onChangeModal}
                  />
                </>
              ))}
            </s.FilterGridWrapper>

            {props.thumbnailFilterQueryInfo.total !== 0 && (
              <PaginationComponent
                rowsPerPage={props.thumbnailFilterQueryInfo.pageLimit}
                rowCount={props.thumbnailFilterQueryInfo.total}
                onChangePage={props.onChangePageFilterTable}
                currentPage={props.thumbnailFilterQueryInfo.pageNum + 1}
              />
            )}
          </>
        ) : (
          <>
            <s.Grid>
              {props.thumbnailList.map((item, index) => (
                <ThumbnailItem
                  index={index}
                  item={item as ThumbnailData}
                  recorderName={item.recorderName}
                  cameraName={item.cameraName}
                  selectedAccount={props.selectedAccount}
                  onChangeModal={props.onChangeModal}
                />
              ))}
            </s.Grid>
            {props.listQueryInfo.total !== 0 && (
              <PaginationComponent
                rowsPerPage={props.listQueryInfo.pageLimit}
                rowCount={props.listQueryInfo.total}
                onChangePage={props.onChangePage}
                currentPage={props.listQueryInfo.pageNum + 1}
              />
            )}
          </>
        )}
      </TableTemplate>
      {props.isModal && props.modalData !== undefined && (
        <BigPopupNoHeaderTemplate>
          <s.ModalHeader>
            <s.ModalInfo>
              <s.ContentInfoItem>
                <Text color={`${COLORS.WHITE}50`}>Recorders</Text>
                <Text bold>{props.modalData.recorderName}</Text>
              </s.ContentInfoItem>

              <s.ContentInfoItem>
                <Text color={`${COLORS.WHITE}50`}>Camera</Text>
                <Text bold>{props.modalData.cameraName}</Text>
              </s.ContentInfoItem>

              <s.ContentInfoItem>
                <Text color={`${COLORS.WHITE}50`}>Date / Time</Text>

                <Text bold>
                  {getRecorderTimeFormat(
                    props.modalData.timestamp,
                    props.selectedAccount,
                    props.modalData.timezone,
                    true,
                    true
                  )}
                </Text>
                {/* {changeTimeStampFormat(
                            item.timestamp,
                            item.timezone
                          )} */}
              </s.ContentInfoItem>
            </s.ModalInfo>

            <button
              onClick={() => props.onChangeModal()}
              data-testid="reports-view-thumbnail-button-change-modal"
            >
              <img alt="close button" src={CLOSE_ICON} />
            </button>
          </s.ModalHeader>
          <s.CvvContainer>
            <DefaultThumbnail>
              <img src={props.modalData.url} alt="thumbnail_image" />
            </DefaultThumbnail>
          </s.CvvContainer>
        </BigPopupNoHeaderTemplate>
      )}
    </>
  );
}
